import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../../utils/buildQuery";

export const ServiceRequestReportApi = createApi({
	reducerPath: "ServicesRequestReport",
	baseQuery: fetchBaseQuery({
		baseUrl: `https://dev.softsprint.ae/backendTest/service-requests`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			headers.set("Accept", "application/json");
			return headers;
		},
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getServiceRequestReport: builder.query({
			query: (params) => {
				const query = buildQuery(params);
				return `/reports/completed${query}`;
			},
		}),

		geServiceRequestFile: builder.query({
			async queryFn(arg, _queryApi, _extraOptions, fetchWithBQ) {
				const { val, startDate, endDate } = arg;
				try {
					const result = await fetch(
						`https://dev.softsprint.ae/backendTest/service-requests/reports/completed/${val}?fromDate=${startDate}&toDate=${endDate}`,
						{
							method: "GET",
							credentials: "include",
							headers: {
								Authorization: `Bearer ${localStorage.getItem("token")}`, // if required
								Accept: "*/*", // let server decide content type (PDF/XLSX)
							},
						}
					);

					if (!result.ok) {
						return {
							error: { status: result.status, data: await result.text() },
						};
					}

					const blob = await result.blob();

					return { data: blob };
				} catch (err) {
					return { error: { status: "FETCH_ERROR", data: err.message } };
				}
			},
		}),
	}),
});

export const {
	useLazyGetServiceRequestReportQuery,
	useLazyGeServiceRequestFileQuery,
} = ServiceRequestReportApi;
